module.exports = __webpack_public_path__ + "static/media/logo-burger-queen.6881bea1.png";